import React, { Component } from 'react';
import Footercontent from './Footercontent';

import texture from '../../assets/img/textures/4.png';

class Footer extends Component {
    render() {
        return (
            <footer className="sigma_footer sigma_footer-dark primary-bg text-black-50"  style={{color: "black !important"}}>
                {/* <img src={texture} className="texture-3" alt="" /> */}
                {/* Bottom Wave */}
                
                <Footercontent />
            </footer>
        );
    }
}

export default Footer;